import { styled } from '@stitches/react'

const HR = styled('div', {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    padding: '1rem 0',
    '&:before': {
        content: '',
        display: 'inline-block',
        flexGrow: 1,
        height: '1px',
        backgroundColor: '#E9E9E9',
    },
    '&:after': {
        content: '',
        display: 'inline-block',
        flexGrow: 1,
        height: '1px',
        backgroundColor: '#E9E9E9',
    },
})

const HorizontalDivider = () => {
    return <HR>Or</HR>
}

export default HorizontalDivider
